import RequestState from 'Enums/RequestState'
import IFFilterType from 'Enums/IFFilterType'

export const INITIAL_STATE = {
  fetchOperatorUserActionsChargePointRequestState: RequestState.UNINITIALIZED,
  fetchOperatorUserActionsRequestState: RequestState.UNINITIALIZED,
  fetchOperatorUserActionsUserRequestState: RequestState.UNINITIALIZED,
  operatorUserActionsChargePoint: [],
  operatorUserActionsChargePointPaginationOffset: 0,
  operatorUserActions: [],
  operatorUserActionsPaginationOffset: 0,
  operatorUserActionsUser: [],
  operatorUserActionsUserPaginationOffset: 0,
  operatorUserActionsFilters: [
    {
      type: IFFilterType.KEYWORD,
      title: null,
      data: null,
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.DATE_RANGE,
      title: 'Date',
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.CHECK,
      title: 'Action',
      data: [
        'Create',
        'Edit',
        'Delete',
        'Activate',
        'Deactivate',
        'Invite',
        'OCPP',
        'Move',
      ],
      initialValue: [],
      value: [],
    },
  ],

  fetchOperatorUserActionsChargingTokenRequestState: RequestState.UNINITIALIZED,
  operatorUserActionsChargingToken: [],
  operatorUserActionsChargingTokenPaginationOffset: 0,
}
